import { useMamAssets } from '~services/api/hooks/mam-assets.hooks';
import { MamDownload } from './MamDownload';

type MamAssetsProps = {
  assetIds: number[];
};

export function MamDownloads({ assetIds }: MamAssetsProps) {
  const { data } = useMamAssets(assetIds);

  if (data?.length) {
    return (
      <>
        {data.map(asset => (
          <MamDownload asset={asset} key={`mam_download_${asset.id}`} as="li" />
        ))}
      </>
    );
  }

  return null;
}
